

function video_control() {
    var video_btn =  document.querySelectorAll(".ris-video-container .ris-btn-video");
    video_btn.forEach(item => {
        console.log("item", item);
        item.addEventListener("click", function() {
            console.log("video button", this.getAttribute("data-mode"));
            var all_videos = document.querySelectorAll("video");
            var btn_video = this;
            all_videos.forEach(video => {
                video.pause();
                if(video.nextElementSibling != btn_video) {
                    video.nextElementSibling.setAttribute("data-mode", "play");
                }
            });

            if(this.getAttribute("data-mode") == "play") {
                this.closest(".ris-video-container").querySelector("video").play();
                this.setAttribute("data-mode", "pause");
            }else {
                this.closest(".ris-video-container").querySelector("video").pause();
                this.setAttribute("data-mode", "play");
            }
        });
    });
}


video_control();
